import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DataService } from '../../service/data.service';

@Component({
  selector: 'app-initiate-tarriff',
  templateUrl: './initiate-tarriff.component.html',
  styleUrls: ['./initiate-tarriff.component.scss']
})
export class InitiateTarriffComponent implements OnInit {
  initiateTarriffForm: FormGroup;
  loadPage: boolean;
  moCallHome:any = [];
  moCallOther: any = [];
  moCallVisited: any = [];
  moSms: any = [];
  tarrifId: any = [];
  tarrifName: any = [];
  tarrif1: any = [];
  tarrif2: any = [];
  tarrif3: any = [];
  tarrif4: any = [];
  tarrif5: any = [];
  tarrif6: any = [];
  tarrif7: any = [];
  tarriffData: [];
  tarriffData1: [];
  tarriffData2: [];
  callVPMNNetwork: boolean;
  submitted = false;  

  constructor(private dialogRef: MatDialogRef<InitiateTarriffComponent>,
    private dataService: DataService,private formBuilder: FormBuilder,
    private router: Router,private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinnerService: Ng4LoadingSpinnerService,
    private endpointsService: EndpointsService,
    private backendApiService: BackendApiService) { 
    this.spinnerService.show();
    }

  ngOnInit(): void {
    this.getApiOnLoad();
    this.createTarriffForm();
    this.loadPage = true;
  }

  createTarriffForm(){
    this.initiateTarriffForm = this.formBuilder.group({
      vpmnCountry: ['ALL', Validators.required],
      vpmnNetwork: ['ALL', Validators.required],
      moCallHome: ['', Validators.required],
      moCallOther: ['', Validators.required],
      moCallVisited: ['', Validators.required],
      moSms: ['', Validators.required],
      gprs: ['', Validators.required],
      tarrifId: ['', Validators.required],
      tarrifName: ['', Validators.required],
      tarrif1: [''],
      tarrif2: [''],
      tarrif3: [''],
      tarrif4: [''],
      tarrif5: [''],
      tarrif6: [''],
      tarrif7: [''],
      startDate: ['2020-03-01'],
      endDate: ['2020-03-12']
    });
  }

  
  get f() {
    return this.initiateTarriffForm.controls;
  }

  async getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.tarriffData1 = response;
      
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.initiateTarriffForm.controls.vpmnNetwork.setValue('1', {onlySelf: true});
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY + 
    '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;

    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.tarriffData2 = response;
      if (this.tarriffData2 && this.tarriffData2.length > 0) {
        this.initiateTarriffForm.controls.vpmnNetwork.setValue(response[0].operator, { onlySelf: true });
      }
      
    });

  }
  

  // changeDateEvent(targetCalendarId: any) {
  //   targetCalendarId.toggle();
  // }

  onClose() {
    this.dialogRef.close();
  }

  // isNullOrEmptyCheck(val) {
  //   for (var v in val) {
  //     if (!val[v] && v !== 'hpmnCountry') {
  //       alert('Please provide the value for ' + this.errorKey[v])
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  onSave(){
    // if (this.isNullOrEmptyCheck(this.initiateTarriffForm.value)) {
    //   if (this.hpmnCountry == null) {
    //     alert('Please choose a file');
    //     return;
    //   }
      this.spinnerService.show();
      this.submitted = true;
      if (this.initiateTarriffForm.invalid) {
        return;
      }
    // this.backendApiService.callToApi(apiUrl).subscribe(response => {
    //   
    //   this.spinnerService.hide();
    //   if (response === null) {
    //     alert('Add Tarriff failed, please contact to Administrator');
    //     return;
    //   } else {
    //     this.dialogRef.close();
    //   }
    // });
    if(this.initiateTarriffForm.get('vpmnCountry').value != 'ALL' && this.initiateTarriffForm.get('vpmnNetwork').value != 'ALL'){
    this.backendApiService.callToApi(this.endpointsService.INSERT_TARRIFF+ '&country=' +
      this.initiateTarriffForm.get('vpmnCountry').value + '&network=' +
        this.initiateTarriffForm.get('vpmnNetwork').value + '&startDate=' +
        this.initiateTarriffForm.get('startDate').value + '&endDate=' +
        this.initiateTarriffForm.get('endDate').value + '&moCallHome=' +
        this.initiateTarriffForm.get('moCallHome').value + '&moCallOther=' +
        this.initiateTarriffForm.get('moCallOther').value + '&moCallVisited=' +
        this.initiateTarriffForm.get('moCallVisited').value + '&moSms=' +
        this.initiateTarriffForm.get('moSms').value + '&gprs=' +
        this.initiateTarriffForm.get('gprs').value + '&tarrif1=' +
        this.initiateTarriffForm.get('tarrif1').value + '&tarrif2=' +
        this.initiateTarriffForm.get('tarrif2').value + '&tarrif3=' +
        this.initiateTarriffForm.get('tarrif3').value + '&tarrif4=' +
        this.initiateTarriffForm.get('tarrif4').value + '&tarrif5=' +
        this.initiateTarriffForm.get('tarrif5').value + '&tarrif6=' +
        this.initiateTarriffForm.get('tarrif6').value + '&tarrif7=' +
        this.initiateTarriffForm.get('tarrif7').value + '&tarrifName=' +
        this.initiateTarriffForm.get('tarrifName').value + '&tarrifId=' +
        this.initiateTarriffForm.get('tarrifId').value+'&userName=' +
        sessionStorage.getItem('ecowas_user_name') +'&userOrgId='+
        sessionStorage.getItem('userOrgId'))
        .subscribe(response => {
          
          this.spinnerService.hide();
 
        // if (response) {
        //     alert('Added successfully');
        //     this.dialogRef.close();
        //   } else {
        //     alert('Not uploaded');
        //   }
        if (response === null) {
          alert('Tariff add failed');
          return;
        } else if (response == true) {
          alert('Tariff added successfully');
          this.dialogRef.close();
        } else {
          alert('Tariff add failed');
          return;
        }
        });  
      }

      else{

        alert('Please Select VPMN Country');
        return;
      }

    }
  }